import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Cookie } from "lucide-react";

const KEY = "dt_cookie_consent";

/** Cookie consent gate. The privacy policy promises consent before tracking,
 *  so PostHog analytics and session recording stay inert until the visitor
 *  accepts here (audit finding DT-P1-12 / DT-P2-11). */
export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      /* storage blocked — don't nag, and stay opted out */
    }
  }, []);

  const decide = (choice) => {
    try { localStorage.setItem(KEY, choice); } catch { /* ignore */ }
    if (choice === "granted" && typeof window.__dtStartAnalytics === "function") {
      window.__dtStartAnalytics();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] border-t border-border bg-card/95 backdrop-blur-xl
                 animate-in slide-in-from-bottom duration-500"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
    >
      <div className="mx-auto max-w-6xl px-6 py-5 flex flex-col md:flex-row md:items-center gap-5">
        <Cookie className="h-6 w-6 text-primary shrink-0" aria-hidden="true" />
        <div className="flex-1">
          <p className="text-sm text-foreground">
            We use essential cookies to keep you signed in. With your permission we also use
            analytics cookies to understand how the site is used.
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Nothing is tracked until you choose.{" "}
            <Link to="/privacy" className="underline hover:text-primary" data-testid="cookie-consent-privacy-link">
              Read our privacy policy
            </Link>
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button
            variant="outline"
            className="rounded-sm text-xs"
            onClick={() => decide("denied")}
            data-testid="cookie-consent-decline"
          >
            Essential only
          </Button>
          <Button
            className="rounded-sm text-xs"
            onClick={() => decide("granted")}
            data-testid="cookie-consent-accept"
          >
            Accept analytics
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
